// Categories
import { saleAndArchiveRedirects } from "./categories/sale-xx-and-archive-xx";

// Products
import { axionAndAxionRaceMipsRedirects } from "./products/axion-and-axion-race-mips";
import { cerebelRedirects } from "./products/cerebel";
import { craneMipsRedirects } from "./products/crane-mips";
import { cytalAndCularisRedirects } from "./products/cytal-and-cularis";
import { cytalCarbonProcenAirRedirects } from "./products/cytal-carbon-procen-air";
import { cytalEfProTeamRedirects } from "./products/cytal-ef-pro-team";
import { cytalLiteAndCytalAmaniEdRedirects } from "./products/cytal-lite-and-cytal-amani-ed";
import { kortalAndKortalRaceMipsRedirects } from "./products/kortal-and-kortal-race-mips";
import { octalMipsAndOctalXMipsRedirects } from "./products/octal-mips-and-octal-x-mips";
import { omneLiteAndOmneAirMipsAndOmneUltraRedirects } from "./products/omne-lite-and-omne-air-mips-and-omne-ultra";
import { otoconAndOtoconRaceMipsRedirects } from "./products/otocon-and-otocon-race-mips";
import { pocitoCraneAndPocitoCraneMipsAndPocitoOmneMipsRedirects } from "./products/pocito-crane-and-pocito-crane-mips-and-pocito-omne-mips";
import { tectalAndTectalRaceMipsRedirects } from "./products/tectal-and-tectal-race-mips";
import { ventralAirMipsAndVentralAirWfMipsRedirects } from "./products/ventral-air-mips-and-ventral-air-wf-mips";
import { ventralLiteVentralMipsRedirects } from "./products/ventral-lite-and-ventral-mips";
import { ventralTempusMipsRedirects } from "./products/ventral-tempus-mips";


export const redirects = [
    ...saleAndArchiveRedirects,
    ...axionAndAxionRaceMipsRedirects,
    ...cerebelRedirects,
    ...craneMipsRedirects,
    ...cytalAndCularisRedirects,
    ...cytalCarbonProcenAirRedirects,
    ...cytalLiteAndCytalAmaniEdRedirects,
    ...cytalEfProTeamRedirects,
    ...kortalAndKortalRaceMipsRedirects,
    ...octalMipsAndOctalXMipsRedirects,
    ...omneLiteAndOmneAirMipsAndOmneUltraRedirects,
    ...otoconAndOtoconRaceMipsRedirects,
    ...pocitoCraneAndPocitoCraneMipsAndPocitoOmneMipsRedirects,
    ...tectalAndTectalRaceMipsRedirects,
    ...ventralAirMipsAndVentralAirWfMipsRedirects,
    ...ventralLiteVentralMipsRedirects,
    ...ventralTempusMipsRedirects,
]
